// extracted by mini-css-extract-plugin
export var aboveInput = "_n9-0";
export var actionButton = "_n9-5";
export var actionButtonContainer = "_n9-1";
export var actionIcon = "_n9-6";
export var aiInfoContainer = "_n9-2";
export var attachmentWrapper = "_n9-7";
export var bold = "_n9-3";
export var checkIcon = "_n9-8";
export var clickingRecipientBar = "_n9-11";
export var commentThreadSwitch = "_n9-a";
export var draftImage = "_n9-b";
export var draftImageContainer = "_n9-c";
export var draftImages = "_n9-e";
export var editButton = "_n9-g";
export var editor = "_n9-f";
export var editorContainer = "_n9-y";
export var editorErrorTooltipWrapper = "_n9-9";
export var headerDivider = "_n9-h";
export var icon = "_n9-i";
export var info = "_n9-j";
export var internal = "_n9-n";
export var internalDivider = "_n9-k";
export var internalMessage = "_n9-l";
export var messageInputCard = "_n9-m";
export var messageInputForm = "_n9-o";
export var messageInputFormInternal = "_n9-p";
export var options = "_n9-q";
export var publicMessageCustomer = "_n9-s";
export var publicMessageMerchant = "_n9-r";
export var removeImageButton = "_n9-d";
export var replyButtons = "_n9-t";
export var showSignatureButton = "_n9-u";
export var spinner = "_n9-v";
export var verticalButtonDivider = "_n9-4";
export var visibilitySelector = "_n9-w";
export var warning = "_n9-x";
export var wrappingText = "_n9-z";
export var writingInternalNoteTopBorder = "_n9-10";